import React from 'react';
import ProgressBar from 'Components/ProgressBar';

const useComponent = () => {
  const thereIsComponent = (data, index) => {
    if (index === 4) {
      const evaluations = data[index];
      const totalEvaluations = evaluations ? evaluations.totalLessonsCount : 0;
      const totalManual = evaluations ? evaluations.totalLessonsCompletedManual : 0;
      const totalAutomatic = evaluations ? evaluations.totalLessonsCompletedAutomatic : 0;
      const totalCompletedEvaluations = totalManual + totalAutomatic;
      return (
        <>
          {totalCompletedEvaluations} / {totalEvaluations}
          {totalEvaluations > 0 && <ProgressBar value={(totalCompletedEvaluations / totalEvaluations) * 100} />}
        </>
      );
    }
    return data[index];
  };

  return {
    thereIsComponent,
  };
};

export default useComponent;
